import { useWidget } from '../../../../../providers/widget'
import { ExploreWidgetConfig } from '../../../config'

/**
 * Compact bar layout (#1700, toolkit `bar_layout`). One hook over
 * `searchbar.barLayout` and the three compact placeholders so every desktop
 * field reads the same resolved values. Only the desktop bar consumes it: the
 * phone sheet stages (the `sheet` branches) keep the labelled markup and the
 * stock idle texts, matching the toolkit ("the phone search flow is
 * unchanged"). Each leaf is read explicitly so the settings-to-behavior flow
 * stays traceable by the dead-setting sentinel.
 */
export function useSbpCompact() {
  const { options } = useWidget<ExploreWidgetConfig>()
  const sb = options.searchbar
  return {
    compact: sb.barLayout === 'compact',
    placeholderWhere: sb.compactPlaceholderWhere,
    placeholderWhen: sb.compactPlaceholderWhen,
    placeholderWho: sb.compactPlaceholderWho,
  }
}

/**
 * A field's name in compact: the label row is gone visually, but the text
 * stays in the DOM, screen-reader only, so a button still announces
 * "When Dates" rather than a bare placeholder. Rendered in place of the
 * `.hfse-sbp-field-label` span.
 */
export function SrLabel({ children }: { children: string }) {
  return <span className="hfse-sbp-sr-label">{children}</span>
}

/** Sliders mark for the icon-only Filters button (toolkit search-bar.php, __field-icon slot). */
export function FiltersIcon() {
  return (
    <span className="hfse-sbp-field-icon" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" focusable="false">
        <path d="M2 4.5h2M9 4.5h9M2 10h9M16 10h2M2 15.5h2M9 15.5h9" />
        <circle cx="6.5" cy="4.5" r="2.25" />
        <circle cx="13.5" cy="10" r="2.25" />
        <circle cx="6.5" cy="15.5" r="2.25" />
      </svg>
    </span>
  )
}
